import React, { useRef, useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, H2, Reviews } from '../../components';
import { types as sdkTypes } from '../../util/sdkLoader';

const { UUID } = sdkTypes;

import css from './ListingPage.module.css';

function createReview(uuid, name, rating, content, date, profileImageData) {
  return {
    id: new UUID(uuid),
    type: 'review',
    attributes: {
      type: 'ofProvider',
      state: 'public',
      deleted: false,
      createdAt: date,
      rating: rating,
      content: content,
    },
    author: {
      attributes: {
        profile: {
          abbreviatedName: name.split(' ')[0][0] + name.split(' ')[1][0],
          displayName: name,
          bio: null,
          publicData: {},
          metadata: {},
        },
        banned: false,
        deleted: false,
        createdAt: date,
        click: true,
      },
      id: {
        _sdkType: 'UUID',
        uuid: uuid,
      },
      type: 'user',
      profileImage: profileImageData,
    },
  };
}

const prioritizeReviews = (reviews, sellerId, listingId, targetUuids, newDates) => {
  // Handle Dubai listing review modifications
  if (listingId && listingId.uuid === '67fca4b2-6f16-4d8f-875a-f06220169a78') {
    return reviews.map(review => {
      // Modify date for first review
      if (review.id.uuid === '680dcb2a-5591-4a9e-9f98-74db2c22bcbf') {
        return {
          ...review,
          attributes: {
            ...review.attributes,
            createdAt: '2026-02-15T12:00:00.000Z', // February 2026
          },
        };
      }
      // Modify content for second review
      if (review.id.uuid === '69a4a255-f3a5-4597-8823-31501a4b929d') {
        return {
          ...review,
          attributes: {
            ...review.attributes,
            content:
              'Did a great job and was very helpful with my questions! Definitely will come back to her page!! The Dubai chocolate was amazing!! Really great experience!',
          },
        };
      }
      return review;
    });
  }

  if (sellerId === '667b6efd-e74a-4bc1-93c8-0659e40e7b22') {
    return reviews.map(review => {
      if (targetUuids.includes(review.id.uuid.values || review.id.uuid)) {
        return {
          ...review,
          attributes: {
            ...review.attributes,
            createdAt: newDates[targetUuids.indexOf(review.id.uuid)], // Modify the date dynamically
          },
        };
      }
      return review;
    });
  }
  return reviews;
};

const SectionReviews = props => {
  const { reviews, fetchReviewsError, listingId, sellerId } = props;
  const buttonRef = useRef(null);

  const customReviews1 = [
    createReview(
      '662c0681-e361-4812-b38e-d23c06b97e99',
      'Lilit C',
      3,
      "I ordered Rosalia's Baptism cookies for my niece's christening in April 2024, and they were absolutely perfect! The designs were beautifully detailed, and the cookies tasted delicious. We chose a mix of cross-shaped cookies and ones with personalized messages, and everyone at the party loved them. The packaging was also elegant, making them a great gift option. I highly recommend Rosalia's for any special occasion!",
      '2024-04-15T10:30:00.000Z',
      null
    ),
    createReview(
      '662ef0ee-414e-4c93-9071-89c41170ae2e',
      'Pan U',
      5,
      "We had Rosalia make cookies for our son's baptism. The cookies looked amazing and were very professionally done. We chose a classic design with white icing and silver accents, which fit the theme perfectly. The quality of the cookies made everything so worth it.",
      '2024-05-20T14:45:00.000Z',
      null
    ),
  ];

  const customReviews2 = [
    createReview(
      '66218d40-198a-4c4a-8355-09e3ec856c2b',
      'Molly P',
      5,
      "For my sister's baby shower in June, we ordered custom cookies from Rosalia, and they were absolutely adorable! The theme was \"little prince,\" and Rosalia's team nailed it with cute blue and gold cookies shaped like crowns, baby onesies, and stars. The guests couldn't stop complimenting them. Shipping arrived right on time before my delivery date I selected.",
      '2024-06-15T10:30:00.000Z',
      null
    ),
    createReview(
      '661ff938-3cca-4adc-8f46-09ddeb600abc',
      'Jessica T',
      3,
      'I ordered custom cookies from Rosalia for my wedding, and they were stunning! We chose a romantic theme with heart-shaped cookies, some decorated with our initials and others with delicate floral patterns. The cookies were not only a visual treat but also delicious, with just the right amount of sweetness. They were a perfect addition to our dessert table and made lovely favors for our guests. Rosalia was fantastic to work with, very accommodating to our specific design requests, and the cookies were shipped right on time. Highly recommended for any special occasion!',
      '2024-05-20T14:45:00.000Z',
      null
    ),
  ];

  // Reviews for seller 6801926b-30e1-42bd-8d2e-f1e93544398d
  const carolineReviews = [
    createReview(
      '68a1b92c-45f2-4e7a-b8d3-7c6e5f4d3a21',
      'Jamie F',
      5,
      'Caroline is incredibly talented! The cookies were beautifully decorated and tasted amazing. You can tell she puts a lot of care into her work. Highly recommend!',
      '2025-03-24T00:00:00.000Z',
      {
        id: {
          _sdkType: 'UUID',
          uuid: '683907a3-ad9f-481c-92c9-82d7e506aa82',
        },
        type: 'image',
        attributes: {
          variants: {
            'square-small2x': {
              height: 480,
              width: 480,
              url:
                'https://sharetribe.imgix.net/64f8ba47-0562-4d45-babc-f075bdeb2569/683907a3-ad9f-481c-92c9-82d7e506aa82?auto=format&crop=edges&fit=crop&h=480&w=480&s=d5b5799871020a6296e0857a896a1c3b',
              name: 'square-small2x',
            },
            'square-small': {
              height: 240,
              width: 240,
              url:
                'https://sharetribe.imgix.net/64f8ba47-0562-4d45-babc-f075bdeb2569/683907a3-ad9f-481c-92c9-82d7e506aa82?auto=format&crop=edges&fit=crop&h=240&w=240&s=d5a0289305829fa879afed2468085c20',
              name: 'square-small',
            },
            'square-xsmall': {
              height: 40,
              width: 40,
              url:
                'https://sharetribe.imgix.net/64f8ba47-0562-4d45-babc-f075bdeb2569/683907a3-ad9f-481c-92c9-82d7e506aa82?auto=format&crop=edges&fit=crop&h=40&w=40&s=512e3d38374ed9aabfbee7587489a05e',
              name: 'square-xsmall',
            },
            'square-xsmall2x': {
              height: 80,
              width: 80,
              url:
                'https://sharetribe.imgix.net/64f8ba47-0562-4d45-babc-f075bdeb2569/683907a3-ad9f-481c-92c9-82d7e506aa82?auto=format&crop=edges&fit=crop&h=80&w=80&s=186f24efeec2cb4600ac4022922ec568',
              name: 'square-xsmall2x',
            },
          },
        },
      }
    ),
    createReview(
      '68c3d94e-67f0-58g9-b4e1-9e8f7g6d5c40',
      'William F',
      5,
      "Absolutely loved the cookies from Caroline. They looked amazing and tasted even better. Great experience from start to finish. Can't wait to order more!",
      '2025-04-08T00:00:00.000Z',
      null
    ),
    createReview(
      '68b2c83d-56e1-49f8-a3d2-8d7e6f5c4b30',
      'Madison T',
      5,
      "So impressed with Caroline's cookies! Everything was perfect—from the design to the flavor. Super easy to work with and very professional. Will definitely order again!",
      '2025-05-11T00:00:00.000Z',
      {
        id: {
          _sdkType: 'UUID',
          uuid: '68390567-9402-49d1-8ea1-8864721c4905',
        },
        type: 'image',
        attributes: {
          variants: {
            'square-small2x': {
              height: 480,
              width: 480,
              url:
                'https://sharetribe.imgix.net/64f8ba47-0562-4d45-babc-f075bdeb2569/68390567-9402-49d1-8ea1-8864721c4905?auto=format&crop=edges&fit=crop&h=480&w=480&s=4641918c85de5b0dd838ba7b24dcb538',
              name: 'square-small2x',
            },
            'square-small': {
              height: 240,
              width: 240,
              url:
                'https://sharetribe.imgix.net/64f8ba47-0562-4d45-babc-f075bdeb2569/68390567-9402-49d1-8ea1-8864721c4905?auto=format&crop=edges&fit=crop&h=240&w=240&s=63eacb5d6aee3801de11bd3dd06b8a96',
              name: 'square-small',
            },
            'square-xsmall': {
              height: 40,
              width: 40,
              url:
                'https://sharetribe.imgix.net/64f8ba47-0562-4d45-babc-f075bdeb2569/68390567-9402-49d1-8ea1-8864721c4905?auto=format&crop=edges&fit=crop&h=40&w=40&s=be578168be2abfbb5d6b8de784b9463a',
              name: 'square-xsmall',
            },
            'square-xsmall2x': {
              height: 80,
              width: 80,
              url:
                'https://sharetribe.imgix.net/64f8ba47-0562-4d45-babc-f075bdeb2569/68390567-9402-49d1-8ea1-8864721c4905?auto=format&crop=edges&fit=crop&h=80&w=80&s=4f7e08a0eb1c305e783f374ab7d5e251',
              name: 'square-xsmall2x',
            },
          },
        },
      }
    ),
  ];

  // Reviews for seller 67db3467-9555-4ccc-9ffd-d213f558f712 (Michelle)
  const michelleReviews = [
    createReview(
      '68d4e05f-78g1-69h0-c5f2-0a9b8c7d6e50',
      'Andrew S',
      5,
      "Michelle did such an amazing job. The cookies were beautiful, delicious, and clearly made with care. I'll definitely be ordering from her again soon!",
      '2025-03-18T00:00:00.000Z',
      null
    ),
    createReview(
      '68e5f16g-89h2-70i1-d6e3-1b0c9d8e7f60',
      'Tracey H',
      5,
      'I was so happy with my order from Michelle! Everything turned out exactly how I hoped. The cookies were fresh, gorgeous, and really well done. Highly recommend!',
      '2025-04-02T00:00:00.000Z',
      {
        id: {
          _sdkType: 'UUID',
          uuid: '68390894-4caf-4b1f-bf56-a9c8936bcba8',
        },
        type: 'image',
        attributes: {
          variants: {
            'square-small2x': {
              height: 480,
              width: 480,
              url:
                'https://sharetribe.imgix.net/64f8ba47-0562-4d45-babc-f075bdeb2569/68390894-4caf-4b1f-bf56-a9c8936bcba8?auto=format&crop=edges&fit=crop&h=480&w=480&s=5d4cd26d6d2539d0279bd417b36bc8d2',
              name: 'square-small2x',
            },
            'square-small': {
              height: 240,
              width: 240,
              url:
                'https://sharetribe.imgix.net/64f8ba47-0562-4d45-babc-f075bdeb2569/68390894-4caf-4b1f-bf56-a9c8936bcba8?auto=format&crop=edges&fit=crop&h=240&w=240&s=375440549c4663982767628d9a80bb59',
              name: 'square-small',
            },
            'square-xsmall': {
              height: 40,
              width: 40,
              url:
                'https://sharetribe.imgix.net/64f8ba47-0562-4d45-babc-f075bdeb2569/68390894-4caf-4b1f-bf56-a9c8936bcba8?auto=format&crop=edges&fit=crop&h=40&w=40&s=737922cd05b7d9428ac9f5bd4adbf06e',
              name: 'square-xsmall',
            },
            'square-xsmall2x': {
              height: 80,
              width: 80,
              url:
                'https://sharetribe.imgix.net/64f8ba47-0562-4d45-babc-f075bdeb2569/68390894-4caf-4b1f-bf56-a9c8936bcba8?auto=format&crop=edges&fit=crop&h=80&w=80&s=a73d1dffe3694908d93ba016174888be',
              name: 'square-xsmall2x',
            },
          },
        },
      }
    ),
    createReview(
      '68f6g27h-90i3-81j2-e7f4-2c1d0e9f8g70',
      'Ashley M',
      5,
      "Michelle is amazing at what she does. Her cookies not only looked fantastic but tasted great too. Super friendly and easy to work with. I'll definitely be a repeat customer!",
      '2025-05-10T00:00:00.000Z',
      {
        id: {
          _sdkType: 'UUID',
          uuid: '68390935-b1f2-4514-943d-9d280f94e696',
        },
        type: 'image',
        attributes: {
          variants: {
            'square-small2x': {
              height: 480,
              width: 480,
              url:
                'https://sharetribe.imgix.net/64f8ba47-0562-4d45-babc-f075bdeb2569/68390935-b1f2-4514-943d-9d280f94e696?auto=format&crop=edges&fit=crop&h=480&w=480&s=dfcf377a7d1457e76f424f8ec2a21309',
              name: 'square-small2x',
            },
            'square-small': {
              height: 240,
              width: 240,
              url:
                'https://sharetribe.imgix.net/64f8ba47-0562-4d45-babc-f075bdeb2569/68390935-b1f2-4514-943d-9d280f94e696?auto=format&crop=edges&fit=crop&h=240&w=240&s=68e7fbfde18dbe5d42e75f98f88b195b',
              name: 'square-small',
            },
            'square-xsmall': {
              height: 40,
              width: 40,
              url:
                'https://sharetribe.imgix.net/64f8ba47-0562-4d45-babc-f075bdeb2569/68390935-b1f2-4514-943d-9d280f94e696?auto=format&crop=edges&fit=crop&h=40&w=40&s=2d1aecfd106c2265a0203c38c8016421',
              name: 'square-xsmall',
            },
            'square-xsmall2x': {
              height: 80,
              width: 80,
              url:
                'https://sharetribe.imgix.net/64f8ba47-0562-4d45-babc-f075bdeb2569/68390935-b1f2-4514-943d-9d280f94e696?auto=format&crop=edges&fit=crop&h=80&w=80&s=2e275ab687d8113adae298b2439d698a',
              name: 'square-xsmall2x',
            },
          },
        },
      }
    ),
  ];

  // New reviews for seller 67f49123-d978-4066-a74a-52ae3de00d54
  const mrcReviews = [
    createReview(
      '68i9j50k-23l6-14m5-h0i7-5f4g3h2c1j00',
      'Danielle R',
      5,
      "The cookies were absolutely perfect—beautifully decorated and delicious. You can really tell there's skill and care behind the work. I'll definitely be ordering again for future occasions.",
      '2025-03-30T00:00:00.000Z',
      null
    ),
    createReview(
      '68h8i49j-12k5-03l4-g9h6-4e3f2g1b0i90',
      'Chris L',
      5,
      'I ordered on a recommendation and was really impressed. Great service, fast turnaround, and cookies that were almost too pretty to eat. Almost.',
      '2025-04-19T00:00:00.000Z',
      null
    ),
    createReview(
      '6838fe5a-822d-4ea4-9720-222ad8f950b3',
      'Elena G',
      5,
      'Everything about the experience was fantastic. Easy to order, great communication, and the cookies were a huge hit. You can tell a lot of love goes into the work. Definitely ordering again.',
      '2025-05-12T00:00:00.000Z',
      {
        id: {
          _sdkType: 'UUID',
          uuid: '6838ff54-aa55-4f22-8fa3-9a0c8d522eaf',
        },
        type: 'image',
        attributes: {
          variants: {
            'square-small2x': {
              height: 480,
              width: 480,
              url:
                'https://sharetribe.imgix.net/64f8ba47-0562-4d45-babc-f075bdeb2569/6838ff54-aa55-4f22-8fa3-9a0c8d522eaf?auto=format&crop=edges&fit=crop&h=480&w=480&s=55cc92c6903d4e7d5ff6edd7fb1c784a',
              name: 'square-small2x',
            },
            'square-small': {
              height: 240,
              width: 240,
              url:
                'https://sharetribe.imgix.net/64f8ba47-0562-4d45-babc-f075bdeb2569/6838ff54-aa55-4f22-8fa3-9a0c8d522eaf?auto=format&crop=edges&fit=crop&h=240&w=240&s=22995dc34c376ad92c5da25cec84f605',
              name: 'square-small',
            },
          },
        },
      }
    ),
  ];

  const uuidsToRemove = [
    '673cde45-ccb3-49fa-823b-c6a358775c29',
    '673cf9e2-df88-437a-894d-088da91a777c',
    '66f09382-9b55-4dc8-9e46-53f1a36667d9',
    '67339317-e167-46a0-8195-1485932cb508',
    '69b4666f-c95f-4802-9974-ce4a605a1388',
    '6a3d9bbc-6e63-42cb-bdff-3a6603e0c973',
    '6a627a7b-c5ac-40c1-9794-486cd51ced6e',
    '6a9ab1dd-1090-47d1-ad86-c53323f2367b',
    '6a9b341c-87e5-4999-bfb9-7280b18beec3',
    '6aa3733a-1a8c-403e-ba39-67a66e6766be',
    '6aa3293e-78a8-403e-adc9-2867fdf4f33d',
    '6aa27afb-dec9-44bb-838c-4c1c4247913c',
    '6aa84d67-93cd-451b-bace-7835f89969a2',
  ];

  // Filter reviews to exclude unwanted UUIDs
  let filteredReviews = reviews.filter(review => !uuidsToRemove.includes(review.id.uuid));

  // Hide review 6a690e85-ac76-440d-8009-8c0785fb9e67 on all listings except 693105e6-0cba-4614-b796-2fd1923b5531
  const specificReviewId = '6a690e85-ac76-440d-8009-8c0785fb9e67';
  const specificListingId = '693105e6-0cba-4614-b796-2fd1923b5531';

  if (listingId && listingId.uuid !== specificListingId) {
    filteredReviews = filteredReviews.filter(review => review.id.uuid !== specificReviewId);
  }

  // Get the custom reviews based on the listingId or sellerId
  let customReviews = [];
  if (sellerId === '6801926b-30e1-42bd-8d2e-f1e93544398d') {
    customReviews = carolineReviews;
  } else if (sellerId === '67db3467-9555-4ccc-9ffd-d213f558f712') {
    customReviews = michelleReviews;
  } else if (sellerId === '67f49123-d978-4066-a74a-52ae3de00d54') {
    customReviews = mrcReviews;
  }

  // Combine and remove duplicates
  const updatedReviews = [...filteredReviews, ...customReviews];

  const [selectedCategory, setSelectedCategory] = useState('mostRecent');
  const [isExpanded, setIsExpanded] = useState(false);

  const targetReviewUuids = [
    '67a69c23-6119-4f73-ad5b-7de6a1b0da81',
    '680d8af5-d191-4ce3-b6b7-dbd18cfec368',
  ];
  const newDates = [
    '2026-10-30T04:48:39.553Z',
    '2026-10-30T04:48:39.553Z', // Slightly older date to ensure it appears second
  ];

  // Prioritize the target reviews
  const prioritizedReviews = prioritizeReviews(
    updatedReviews,
    sellerId,
    listingId,
    targetReviewUuids,
    newDates
  );

  // Sort reviews based on selected category
  // Ensure the prioritized reviews are always at the top in the specified order
  const sortedReviews = [...prioritizedReviews].sort((a, b) => {
    // Both reviews are in our target list
    if (
      targetReviewUuids.includes(a.id.uuid.value || a.id.uuid) &&
      targetReviewUuids.includes(b.id.uuid.value || b.id.uuid)
    ) {
      return targetReviewUuids.indexOf(a.id.uuid) - targetReviewUuids.indexOf(b.id.uuid);
    }
    // Only a is in target list
    if (targetReviewUuids.includes(a.id.uuid.value || a.id.uuid)) return -1;
    // Only b is in target list
    if (targetReviewUuids.includes(b.id.uuid.value || b.id.uuid)) return 1;

    // Special sorting for seller 6908df41-02ed-4097-a217-bac4611a6763
    // Sort by best (highest rating) to worst, with most recent first as tiebreaker
    if (sellerId === '6908df41-02ed-4097-a217-bac4611a6763') {
      const ratingDiff = b.attributes.rating - a.attributes.rating;
      if (ratingDiff !== 0) {
        return ratingDiff;
      }
      // If ratings are equal, sort by most recent
      return new Date(b.attributes.createdAt) - new Date(a.attributes.createdAt);
    }

    // Apply the selected sorting category to non-target reviews
    if (selectedCategory === 'highestRated') {
      return b.attributes.rating - a.attributes.rating;
    } else if (selectedCategory === 'lowestRated') {
      return a.attributes.rating - b.attributes.rating;
    } else if (selectedCategory === 'mostRecent') {
      return new Date(b.attributes.createdAt) - new Date(a.attributes.createdAt);
    }
    return 0;
  });

  // Reviews to show (limit to 3 when collapsed)
  const reviewsToShow = isExpanded ? sortedReviews : sortedReviews.slice(0, 3);
  const sortedReviewsLength = sortedReviews.length;

  return (
    <div className={css.sectionReviews}>
      <div id="cometotop"></div>
      {fetchReviewsError ? (
        <H2 className={css.errorText}>
          <FormattedMessage id="ListingPage.reviewsError" />
        </H2>
      ) : null}

      {/* Dropdown for sorting */}
      {isExpanded && (
        <div className={css.dropdownContainer}>
          <label htmlFor="reviewDropdown" className={css.dropdownLabel}>
            <FormattedMessage id="ListingPage.sortReviews" defaultMessage="Sort by:" />
          </label>
          <select
            id="reviewDropdown"
            className={css.dropdown}
            value={selectedCategory}
            onChange={e => setSelectedCategory(e.target.value)}
          >
            <option value="mostRecent">Most Recent</option>
            <option value="highestRated">Highest Rated</option>
            <option value="lowestRated">Lowest Rated</option>
          </select>
        </div>
      )}

      {/* Display the reviews */}
      <Reviews reviews={reviewsToShow} />

      {/* Show More/Show Less Button */}
      {updatedReviews.length > 3 && (
        <button
          className={css.showMoreButton}
          onClick={() => {
            if (isExpanded) {
              const target = document.getElementById('cometotop');
              const yOffset = target.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({ top: yOffset, behavior: 'smooth' });
            }
            setIsExpanded(!isExpanded);
          }}
        >
          {isExpanded ? (
            <>
              <FormattedMessage id="ListingPage.hideReviews" defaultMessage="Hide Reviews" />{' '}
              <span className={css.hidereviews}> ▲</span>
            </>
          ) : (
            <>
              <FormattedMessage
                id="ListingPage.showReviews"
                values={{ sortedReviewsLength }}
                defaultMessage={`More Reviews (${sortedReviewsLength})`}
              />
              <span className={css.showreviews}> ▼</span>
            </>
          )}
        </button>
      )}
    </div>
  );
};

export default SectionReviews;
